import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AnalyticsManager from '../../../../app/analytics';
import { generateUniqueId, getMediaPath } from '../../../../app/functions';
import * as routes from '../../../../constants/routes';
import './index.scss';

const MegaMenuCategory = ({ data }) => {
    const { id, title, imagePath, subCatsArr, searchParams, externalLink } = data;

    const megaMenuMaxSubCategories = useSelector((store) => store.config.megaMenuMaxSubCategories);

    const categoryLink = `${routes.category}/${id}/${searchParams.category}`;

    const handleCategoryClick = () => AnalyticsManager.logMenuCategoryPress(id, title);

    const CategoryWrapper = ({ children, className, onClick, internalLink = '', externalLink = '' }) => {
        const hasExternalLink = !!externalLink;

        return React.createElement(
            hasExternalLink ? 'a' : NavLink,
            hasExternalLink
                ? { className, onClick, href: externalLink, target: '_blank' }
                : { className, onClick, to: internalLink },
            children,
        );
    };

    return (
        <div className="mega-menu-category-wrapper">
            <CategoryWrapper
                className="category-header-wrapper"
                onClick={handleCategoryClick}
                internalLink={categoryLink}
                externalLink={externalLink}
            >
                <div className="icon-wrapper">
                    <img src={getMediaPath(imagePath)} alt="/" className="icon" />
                </div>

                <div className="text">
                    {title}
                </div>
            </CategoryWrapper>

            {subCatsArr.map((sub, idx) => {
                if (idx < megaMenuMaxSubCategories) {
                    const categoryLink = `${routes.category}/${sub.id}/${sub.searchParams.category}`;
                    const externalLink = sub.externalLink;

                    const handleSubCategoryClick = () => AnalyticsManager.logMenuSubCategoryPress(sub.id, sub.title);

                    return (
                        <CategoryWrapper
                            key={`${sub.searchParams.category}_${generateUniqueId(8)}`}
                            className="sub-category"
                            onClick={handleSubCategoryClick}
                            internalLink={categoryLink}
                            externalLink={externalLink}
                        >
                            {sub.title}
                        </CategoryWrapper>
                    );
                }
            })}
        </div>
    );
};

export default MegaMenuCategory;
